const firebaseConfig = {
    apiKey: "AIzaSyBgeZZivY3Iw4JDT9S5DPyL95Wm7EDvV2E",
    authDomain: "hot-onion-restaurant-ltd.firebaseapp.com",
    databaseURL: "https://hot-onion-restaurant-ltd.firebaseio.com",
    projectId: "hot-onion-restaurant-ltd",
    storageBucket: "hot-onion-restaurant-ltd.appspot.com",
    messagingSenderId: "923782944543",
    appId: "1:923782944543:web:ac718f054fbe9cd4ba022a"
  };

  export default firebaseConfig;